// This will be replaced after bundling the app by the Embrace SourceUpload CLI tool.
// It needs to always remain 32 chars long, so we don't mess with the sourcemaps location after replacing the bundle id with the real 32 chars long bundle ID
export const TEMPLATE_BUNDLE_ID = 'EmbIOBundleIDfd6996f1007b363f87a';
export const TEMPLATE_APP_VERSION = 'EmbIOAppVersionX.X.X';
export const SDK_VERSION = '1.3.0';
export const EMBRACE_SERVICE_NAME = 'embrace-web-sdk';
// NATIVE_FRAMEWORK is the representation Embrace BE uses to differentiate between
// sdks. It is an enum, so we just send a number here
export const NATIVE_FRAMEWORK = 1;
export const EMBRACE_APP_INSTANCE_ID_STORAGE_KEY = 'embrace_app_instance_id';
